import { doc, updateDoc } from "firebase/firestore";
import { getDb } from "@/services/firebase/config";
import type { TutorialForm } from "@/types/tutorial/Tutorial";

const COLLECTION_NAME = "tutoriais";

class UpdateTutorial {
  execute = async (id: string, tutorial: TutorialForm): Promise<void> => {
    const db = getDb();
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      title: tutorial.title,
      link: tutorial.link,
      category: tutorial.category,
    });
  };
}

export { UpdateTutorial };
